import { combineReducers } from "redux";
import * as types from "../../utils/actionTypes";
import { createReducer } from "../../utils/helpers";

const initialState = {
  activeNode: false,
  nextNode: null,
  clash: {
    title: "Konflikt",
    intro: "Die gewählte Option steht im Konflikt mit anderen Optionen!",
    conflicts: "Nicht kompatibel mit:",
    requires: "Benötigt:",
    appendix: "Gerne werden wir dies mit Ihnen persönlich besprechen.",
  },
  home: {
    intro:
      "Formen Sie jetzt Ihr künftiges Zuhause mit dem Hauskonfigurator und erhalten Sie eine Richtofferte für Ihr Traumhaus.",
    start: "Jetzt starten",
    next: "Konfiguration fortsetzen",
    background: "images/static/background.webp",
  },
  nodes: [],
  area: 0,
  lightbox: "",
};

// ACTIVE NODE
const setActiveNode = (state, payload) =>
  !(payload === null || payload === undefined) && payload;

export const activeNode = createReducer(initialState.activeNode, {
  [types.SET_ACTIVE_NODE]: setActiveNode,
});

// NEXT NODE
const setNextNode = (state, payload) => (payload !== null ? payload : "");

export const nextNode = createReducer(initialState.nextNode, {
  [types.SET_NEXT_NODE]: setNextNode,
});

export const clash = createReducer(initialState.clash, {});

export const home = createReducer(initialState.home, {});

// ALL NODES
const setNodes = (state, payload) => {
  return [...state, ...payload];
};

export const nodes = createReducer(initialState.nodes, {
  [types.SET_NODES]: setNodes,
});

// AREA
const setArea = (_state, payload) => payload;

export const area = createReducer(initialState.area, {
  [types.SET_AREA]: setArea,
});

// LIGHTBOX
export const lightbox = createReducer(initialState.lightbox, {
  [types.SET_LIGHTBOX]: (state, payload) => payload,
});

// Default Export
export default combineReducers({
  activeNode,
  nextNode,
  clash,
  home,
  nodes,
  area,
  lightbox,
});



// WEBPACK FOOTER //
// ./src/modules/core/reducers.js